<template>
  <v-form ref="form" v-model="valid">
    <v-container nowrap>
      <v-card class="elevation-0">
        <v-layout row wrap>
          <v-flex sm12 md6>
            <v-card-title class="headline font-weight-bold"
              >Cadastro de Cliente</v-card-title
            >
          </v-flex>

          <v-flex sm12 md6 class="justify-end justify-space-around pr-4">
            <v-layout align-center justify-end row fill-height>
              <v-tooltip
                bottom
                v-if="
                  user &&
                  user.customer_id &&
                  user.status !== 'ATIVO' &&
                  proposal_validation.ucs.length > 0
                "
              >
                <template v-slot:activator="{ on }">
                  <v-btn round class="mt-2" color="warning" dark v-on="on"
                    >Já foi cliente</v-btn
                  >
                </template>
                <span>
                  <p v-html="assinou" />
                </span>
              </v-tooltip>
              <v-tooltip
                bottom
                v-else-if="
                  user &&
                  user.customer_id &&
                  user.status === 'ATIVO' &&
                  proposal_validation.ucs.length > 0
                "
              >
                <template v-slot:activator="{ on }">
                  <v-btn round class="mt-2" color="green" dark v-on="on"
                    >Cliente Ativo</v-btn
                  >
                </template>
                <span>
                  <p
                    v-html="
                      '<p>O cliente já está ativo.</p><p class=\'font-weight-bold\'>É permitido apenas a adição de novas unidades consumidoras.</p>'
                    "
                  />
                </span>
              </v-tooltip>
              <v-tooltip
                bottom
                v-else-if="
                  proposal_validation.cpf_duplicated &&
                  !proposal_validation.same_email
                "
              >
                <template v-slot:activator="{ on }">
                  <v-btn round class="mt-2" color="red" dark v-on="on"
                    >CPF já existe na base</v-btn
                  >
                </template>
              </v-tooltip>
              <v-tooltip bottom v-if="proposal_validation.financial_pending">
                <template v-slot:activator="{ on }">
                  <v-btn round class="mt-2" color="red" dark v-on="on"
                    >Pendência Financeira</v-btn
                  >
                </template>
                <span>
                  <p
                    v-html="
                      '<p>O cliente possui contas em atraso.</p><p class=\'font-weight-bold\'>É indicado não adicionar novas unidades consumidoras.</p>'
                    "
                  />
                </span>
              </v-tooltip>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-card-text class="pa-0 pt-2">
          <v-layout row wrap>
            <v-container grid-list-md class="pt-0">
              <v-layout class="layoutBorder pa-2">
                <ProposalForm
                  :key="updateComponent"
                  @showUcsList="showUcsList"
                  @clear="clear"
                  @clearForm="clearForm"
                  @disableSell="handleDisableSell"
                />
              </v-layout>

              <v-layout class="layoutBorder mt-2">
                <ConsumerUnitList
                  :key="updateComponent"
                  :isReSubscription="isReSubscription"
                  :selected_plans="selected_plans"
                />
              </v-layout>

              <v-layout class="layoutBorder mt-2">
                <CustomerDadosPessoaisForm
                  :key="updateComponent"
                  :selected_cep="selected_cep"
                />
              </v-layout>

              <v-layout class="layoutBorder mt-2">
                <SalesDataForm
                  ref="salesDataForm"
                  :key="updateComponent"
                  @pickedPhotos="setIdPhoto"
                  @pickIdEnergyPhoto="setIdEnergyBill"
                  @updateUniqueBilling="unique_billing = $event"
                />
              </v-layout>

              <v-layout class="justify-end mt-2">
                <v-btn
                  color="primary"
                  @click.prevent="save(false)"
                  :loading="loading"
                  :disabled="
                    loading_subscription ||
                    !proposal_validation.can_subscription ||
                    isCorreios ||
                    disabledSell
                  "
                  >Salvar</v-btn
                >
                <v-btn
                  color="pink"
                  @click.prevent="subscription"
                  v-if="
                    (this.user.cpf && this.user.cpf !== '') ||
                    (this.user.cnpj && this.user.cnpj !== '')
                  "
                  :loading="loading_subscription"
                  :disabled="
                    !proposal_validation.can_subscription ||
                    isCorreios ||
                    disabledSell
                  "
                  >{{ isReSubscription ? "Reinscrever" : "Inscrever" }}</v-btn
                >
              </v-layout>
            </v-container>
          </v-layout>
        </v-card-text>
      </v-card>
      <v-snackbar
        :color="snackBar.color"
        :bottom="snackBar.bottom"
        :top="snackBar.top"
        :left="snackBar.left"
        :right="snackBar.right"
        multi-line
        v-model="snackBar.snackbar"
        dark
      >
        <v-icon color="white" class="mr-3">mdi-bell-plus</v-icon>
        <div v-html="snackBar.snackMessage"></div>
        <v-icon size="16" @click="snackBar.snackbar = false"
          >mdi-close-circle</v-icon
        >
      </v-snackbar>
    </v-container>
  </v-form>
</template>

<script>
import ConsumerUnitList from "./ConsumerUnitList.vue";
import CustomerDadosPessoaisForm from "./CustomerDadosPessoaisForm.vue";
import ProposalForm from "./ProposalForm.vue";
import SalesDataForm from "./SalesDataForm.vue";
import { addLead } from "../../../services/leads";
import { finishQualification } from "../../../services/qualification";
import { formatPhone } from "../../../utils/utils";
import {
  getComplementaryData,
  updateUser,
  storeCustomer,
  validaCPFNaBase,
} from "../../../services/users";
import { setFbEvent } from "../../../services/facebookOfflineEvents";
import { setWinOpportunity } from "../../../services/rdstation";
import { updateUsedCoupon } from "../../../services/coupon";
import { mapState, mapMutations, mapGetters } from "vuex";
import { uploadData, saveEnergyBill } from "../../../services/sales";
import { hasSomeUserGroupMixin } from "../../../mixin/hasSomeUserGroupMixin.js";

export default {
  name: "CustomerForm",

  props: {
    updateComponent: {
      type: Number,
      default: 1,
    },
  },

  components: {
    ConsumerUnitList,
    CustomerDadosPessoaisForm,
    SalesDataForm,
    ProposalForm,
  },

  mixins: [hasSomeUserGroupMixin],

  created() {
    this.agent_email = this.loggedUser?.email || null;
  },

  data: () => ({
    snackBar: {
      snackbar: false,
      snackMessage: "",
      color: "",
      top: false,
      bottom: false,
      left: false,
      right: false,
    },
    idPhoto: [],
    idEnergyBill: [],
    loading_subscription: false,
    cadLead: "new",
    hasPendingQualification: false,
    loading: false,
    showEditUcs: true,
    selected_cep: null,
    selected_plans: [],
    valid: false,
    agent_email: null,
    qualificationMessage: null,
    unique_billing: false,
    disabledSell: false,
  }),

  computed: {
    ...mapState("sales", [
      "user",
      "plan",
      "proposal_validation",
      "coupon",
      "isCorreios",
      "seller",
    ]),
    ...mapState("qualification", ["qualifications"]),
    ...mapState(["config", "permissions"]),
    ...mapGetters("qualification", ["getQualificationsIds"]),
    ...mapGetters(["loggedUser"]),

    assinou() {
      let msg = "";
      if (!this.user.contract_id && this.user.status !== "ATIVO") {
        msg =
          "Atenção: Cliente fez cadastro no passado e cancelou ou não foi ativado, revender para esse cliente?";
      } else {
        msg =
          'Atenção: Cliente <span class="font-weight-bold">' + this.user.status;
      }
      return msg;
    },

    isReSubscription() {
      return (
        !this.proposal_validation.financial_pending &&
        this.proposal_validation.same_email &&
        this.proposal_validation.can_subscription &&
        this.user.id &&
        this.user.status !== "ATIVO"
      );
    },

    qualification_ids() {
      return this.getQualificationsIds ?? [];
    },
  },

  watch: {
    qualification_ids() {
      this.hasPendingQualification = this.qualification_ids?.length <= 0;
    },
    isReSubscription: {
      handler() {
        this.setReSubscription(this.isReSubscription);
      },
      deep: true,
    },
  },

  methods: {
    ...mapMutations("sales", [
      "setUser",
      "setProposalValidation",
      "setLoading",
      "setIsCorreios",
      "setReSubscription",
    ]),

    async save(finished) {
      if (this.$refs.form.validate()) {
        this.loading = true;
        if (
          this.proposal_validation.ucs?.length > 0 &&
          !this.proposal_validation.can_subscription
        ) {
          console.error(
            "Membro com contrato assinado ou em processo de assinatura não pode ser revendido!",
          );
          this.snack(
            "Membro com contrato assinado ou em processo de assinatura não pode ser revendido!",
            "red",
            "top",
          );
          this.loading = false;
          this.valid = false;
          return false;
        }

        if (this.user?.cpf && this.cadLead === "new") {
          let validaCPF = null;
          if (!this.proposal_validation.cpf_valid)
            validaCPF = await validaCPFNaBase(
              this.user?.cpf,
              this.user?.person_type,
              this.user?.email,
              this.user,
              false,
            );
          if (
            this.proposal_validation.cpf_duplicated &&
            !this.proposal_validation.same_email
          ) {
            console.error(
              "CPF já existe na base com o e-mail " + validaCPF.email_found,
            );
            this.snack(
              "CPF já existe na base com o e-mail " + validaCPF.email_found,
              "red",
              "top",
            );
            this.loading = false;
            this.valid = false;
            return false;
          } else if (!this.proposal_validation.cpf_valid) {
            console.error("CPF/CNPJ inválido!");
            this.snack("CPF/CNPJ inválido!", "red", "top");
            this.loading = false;
            this.valid = false;
            return false;
          }
        }

        let lead = JSON.parse(JSON.stringify(this.user));

        lead.platform = "super";
        lead.status = "SAVED";
        lead.finished = false;
        if (finished) lead.finished = true;
        lead.group = "customer";
        lead.phone = formatPhone(this.user?.phone, "+55");
        if (this.user?.phones) {
          lead.other_phones = this.phones.map((e) => {
            return {
              name: e.name,
              phone: formatPhone(e.phone, "+55"),
            };
          });
        }

        if (this.person_type === "pj") {
          lead.cpf_legal_responsible = this.user?.cpf_legal_responsible;
          lead.enercred_contract = this.user?.enercred_contract;
        }

        if (this.plan) {
          lead.plan = this.plan;
        }

        if (this.user?.cupom) {
          lead.coupon = this.coupon;
        }

        // Salvar
        lead.saved_at = new Date();
        lead.updated_at = new Date();
        lead.saved_by = "SUPER";
        lead.saved_source = this.loggedUser?.partner_id || "enercred";
        lead.saved_partner = this.loggedUser?.email;
        lead.qualification_ids = this.qualification_ids.filter((id) => id);
        lead.unique_billing = this.unique_billing;

        if (this.permissions.choose_seller_in_sale && this.seller) {
          lead.saved_source = this.seller?.partner_id || "enercred";
          lead.saved_partner = this.seller?.email;
        }

        await addLead(lead)
          .then(() => {})
          .catch((error) => {
            console.error("Erro ao gravar lead! Erro: ", error);
            this.snack("Erro ao salvar lead.", "red", "top");
            return false;
          });
        this.loading = false;
        this.$store.commit("sales/setLoading", false);
        if (!finished) {
          this.$emit("closeDialog");
        }
        return true;
      } else {
        this.snack("Preencha todos os campos obrigatórios.", "red", "top");
      }
    },

    async subscription() {
      this.qualificationMessage = null;
      this.loading_subscription = true;

      //Se Todos os dados são validos, inscreve o usuário
      const saved_lead = (await this.save(true)) ? true : false;
      if (this.$refs.form.validate() && saved_lead) {
        if (this.cupom && this.cupom.trim() !== "" && !this.disabledCupom) {
          let valida = await this.validateCupom(this.cupom.trim());
          if (!valida) {
            this.valid = false;
            this.loading_subscription = false;
            return;
          }
        }

        let newUser = JSON.parse(JSON.stringify(this.user));

        if (
          newUser?.utility_company == "cemig" &&
          this.qualification_ids?.length < 1
        ) {
          this.loading_subscription = false;
          this.snack(
            "Selecione pelo menos uma Unidade Consumidora.",
            "red",
            "top",
          );
          return;
        }

        if (this.idEnergyBill?.length < 1) {
          this.loading_subscription = false;
          this.snack("Anexe uma conta de energia.", "red", "top");
          return;
        }

        if (this.idEnergyBill?.find((item) => item.progress != 100)) {
          this.loading_subscription = false;
          this.snack(
            "Aguarde o upload da conta de energia ser concluído.",
            "red",
            "top",
          );
          return;
        }

        if (newUser?.person_type == "pj") {
          const docRule = this.$refs.salesDataForm?.getDocRule();
          if (!docRule?.allow) {
            this.loading_subscription = false;
            this.snack(docRule?.message, "red", "top");
            return;
          }
        }

        newUser.unique_billing = this.unique_billing;
        newUser.qualification_ids = this.qualification_ids;

        if (this.canChooseUniqueBilling) {
          newUser.sales_campaign = "projeto_desunificacao";
        }

        if (this.coupon && typeof this.coupon == "object") {
          newUser.coupon = this.coupon;
          if (this.coupon.type === "referral") {
            newUser.promo_code = this.coupon.user;
          }
        }

        newUser.status = "QUALIFICAR";
        newUser.termo_uso = "Sim";
        newUser.password = newUser.cpf || "Junt0s123!";

        newUser.signedcontract_at = new Date();
        if (newUser.signedcontract_by?.trim() === "")
          newUser.signedcontract_by = "SUPER";
        newUser.signedcontract_source =
          this.loggedUser.partner_id || "enercred";
        newUser.signedcontract_partner = this.loggedUser.email;

        //Grava histórico de venda
        if (!this.user.customer_id) {
          const history = {
            created_at: new Date(),
            user_id: this.loggedUser.email,
            action: "created",
          };
          newUser.history = [];
          newUser.history.push(history);
        } else {
          newUser.history = this.user.history || [];
          const history = {
            created_at: new Date(),
            user_id: this.loggedUser.email,
            action: "updated",
          };
          newUser.history.push(history);
        }

        //Cria o usuário
        if (!this.isReSubscription) {
          //Se for PF Busca dados complementares antes de salvar o user
          if (newUser.person_type === "pf") {
            let complementary_data = await getComplementaryData(newUser.cpf);
            if (complementary_data) {
              newUser = {
                ...newUser,
                ...complementary_data,
              };
            }
          }
          if (this.permissions.choose_seller_in_sale) {
            if (!this.seller) {
              this.loading_subscription = false;
              this.snack("Selecione o vendedor", "red", "top");
              return;
            }
            newUser.signedcontract_source =
              this.seller?.partner_id || "enercred";
            newUser.signedcontract_partner = this.seller?.email;
            newUser.created_by = this.loggedUser?.email;
          }

          await storeCustomer(newUser)
            .then(async (_user) => {
              if (_user.status === 200 && _user.data.id) {
                // Se o cupom possuir planta especifica qualifica com a planta correta
                let power_plant_qualification = null;
                if (this.cupom && this.coupon && this.coupon.power_plant_id)
                  power_plant_qualification = this.coupon.power_plant_id;

                // Se o cupom possuir percentual de desconto persolalizado qualifica com o percentual de desconto do cupom
                let percentage_discount_qualification = null;
                if (
                  this.cupom &&
                  this.coupon &&
                  this.coupon.percentage_discount
                )
                  percentage_discount_qualification =
                    this.coupon.percentage_discount;

                let seller = {
                  signedcontract_at: new Date().toISOString(),
                  signedcontract_by: "SUPER",
                  signedcontract_source:
                    this.loggedUser.partner_id || "enercred",
                  signedcontract_partner: this.loggedUser.email,
                };

                if (this.permissions.choose_seller_in_sale) {
                  seller.signedcontract_source =
                    this.seller?.partner_id || "enercred";
                  seller.signedcontract_partner = this.seller?.email;
                }

                try {
                  await saveEnergyBill(
                    _user.data.id,
                    this.loggedUser?.email,
                    this.idEnergyBill,
                  );
                  this.snack("Conta de energia anexada com sucesso!", "green");
                } catch (error) {
                  this.snack(
                    "Erro ao anexar conta de energia! Tente novamente e acione o setor de TI caso o problema persista.",
                    "red",
                  );
                  console.error(error);
                  this.$store.commit("sales/setLoading", false);
                  this.loading_subscription = false;
                  return;
                }

                try {
                  if (this.idPhoto?.length > 0) {
                    await uploadData({
                      id: _user.data.id,
                      data: this.idPhoto,
                      agent_email: this.loggedUser?.email,
                    });
                    this.snack("Documentos anexados com sucesso!", "green");
                  }
                } catch (error) {
                  this.snack(
                    "Erro ao anexar documentos! Tente novamente e acione o setor de TI caso o problema persista.",
                    "red",
                  );
                  this.$store.commit("sales/setLoading", false);
                  this.loading_subscription = false;
                  return;
                }

                await finishQualification(
                  newUser.cpf,
                  _user.data.id,
                  this.qualification_ids,
                  percentage_discount_qualification,
                  this.unique_billing,
                  power_plant_qualification,
                  newUser.plan,
                  seller,
                  newUser.utility_company,
                  this.agent_email,
                )
                  .then((ret) => {
                    if (ret.status === 200) {
                      if (ret?.data?.results?.some((item) => item.error)) {
                        this.qualificationMessage =
                          " Ainda é necessário qualificar a(s) Unidade(s) Consumidora(s).";
                      }
                      // Se o cliente colocou um Cupom de desconto valido, cria evento no Google Tag Manager
                      if (this.cupom && this.coupon) {
                        //Marca como venda no RDStation
                        setWinOpportunity({
                          event: "SALE",
                          email: newUser.email,
                          sales_value: newUser.average_consumption,
                        })
                          .then(() => {
                            console.log(
                              "Marcado como venda realizada no RDStation",
                            );
                          })
                          .catch((err) => {
                            console.error(err);
                          });

                        // Atualiza a quantidade de uso do Cupon
                        if (newUser.cupom && newUser.coupon)
                          updateUsedCoupon(
                            newUser.coupon.id || newUser.cupom.id,
                          );
                      }
                    } else {
                      this.qualificationMessage =
                        " Ainda é necessário qualificar a(s) Unidade(s) Consumidora(s).";
                    }
                  })
                  .catch((err) => {
                    console.error(err);
                    this.qualificationMessage =
                      " Ainda é necessário qualificar a(s) Unidade(s) Consumidora(s).";
                  });

                // Cadastra evento Offline no facebook
                const valor = newUser.name.split(" ");
                let nome = valor.shift();
                let sobrenome = valor.join(" ");
                let fb_data = {
                  email: newUser.email,
                  fn: nome || newUser.name,
                  ln: sobrenome || newUser.name,
                  phone: newUser.phone,
                  gen: newUser.gender,
                  extern_id: _user.data.id,
                  lead_id: newUser.email,
                  value: newUser.average_consumption || 250,
                  currency: "BRL",
                  customer_id: _user.data.id,
                };
                if (newUser.address?.city) fb_data.ct = newUser.address.city;
                if (newUser.address?.postal_code)
                  fb_data.zip = newUser.address.postal_code;

                setFbEvent(fb_data, "inside_sale", "Purchase");
                this.snack(
                  `Venda realizada com sucesso! ${this.qualificationMessage}`,
                  "green",
                  "top",
                );
                this.$emit(
                  "showStatusSaleSnack",
                  true,
                  this.qualificationMessage,
                );
                this.$emit("closeDialog");
              }
            })
            .catch((error) => {
              console.error("Erro ao realizar venda!", error.message);
              let err_msg = "Erro ao gravar membro! Contate nosso suporte.";
              if (error.code === "auth/email-already-in-use") {
                err_msg = "Este email está sendo utilizado por outra conta.";
              }
              this.snack(err_msg + " - " + error, "red", "top");
            });
        } else {
          // Atualiza o usuário
          const old_sellers = this.user.old_sellers || [];
          if (this.user?.signedcontract_partner) {
            const object = {
              status: this.user.status,
              signedcontract_at: this.user.signedcontract_at,
              signedcontract_by: this.user.signedcontract_by,
              signedcontract_source: this.user.signedcontract_source,
              signedcontract_partner: this.user.signedcontract_partner,
              created_by: this.loggedUser.email,
            };
            old_sellers.push(object);
            if (this.user?.qualification_ids) {
              const qualifications = [
                ...newUser?.qualification_ids,
                ...this.user?.qualification_ids,
              ];
              const filteredQualifications = [...new Set(qualifications)];
              newUser.qualification_ids = filteredQualifications;
            }
            newUser.old_sellers = old_sellers;
          }

          await updateUser(this.user.customer_id, newUser)
            .then(async (user) => {
              if (!user?.data()) {
                console.error("Erro ao atualizar usuário!");
                this.snack("Erro ao reinscrever o membro!", "red");
                this.$store.commit("sales/setLoading", false);
                this.loading_subscription = false;
                return;
              }

              if (!user?.data()?.buyer_id)
                console.error("Usuário (Buyer Id) não foi criado no Pagarme");
              // Se o cupom possuir planta especifica qualifica com a planta correta
              let power_plant_qualification = null;
              if (this.cupom && this.coupon && this.coupon.power_plant_id)
                power_plant_qualification = this.coupon.power_plant_id;

              // Se o cupom possuir percentual de desconto persolalizado qualifica com o percentual de desconto do cupom
              let percentage_discount_qualification = null;
              if (this.cupom && this.coupon && this.coupon.percentage_discount)
                percentage_discount_qualification =
                  this.coupon.percentage_discount;

              const seller = {
                signedcontract_at: new Date().toISOString(),
                signedcontract_by: this.user?.signedcontract_by || "SUPER",
                signedcontract_source: this.loggedUser.partner_id || "enercred",
                signedcontract_partner: this.loggedUser.email,
              };

              try {
                await saveEnergyBill(
                  user.id || this.user.customer_id,
                  this.loggedUser?.email,
                  this.idEnergyBill,
                );
                this.snack("Conta de energia anexada com sucesso!", "green");
              } catch (error) {
                this.snack(
                  "Erro ao anexar conta de energia! Tente novamente e acione o setor de TI caso o problema persista.",
                  "red",
                );
                console.error(error);
                this.$store.commit("sales/setLoading", false);
                this.loading_subscription = false;
                return;
              }

              try {
                if (this.idPhoto?.length > 0) {
                  await uploadData({
                    id: user.id || this.user.customer_id,
                    data: this.idPhoto,
                    agent_email: this.loggedUser?.email,
                  });
                  this.snack("Documentos anexados com sucesso!", "green");
                }
              } catch (error) {
                this.snack(
                  "Erro ao anexar documentos! Tente novamente e acione o setor de TI caso o problema persista.",
                  "red",
                );
                this.$store.commit("sales/setLoading", false);
                this.loading_subscription = false;
                return;
              }

              await finishQualification(
                newUser.cpf,
                user.id,
                this.qualification_ids,
                percentage_discount_qualification,
                this.unique_billing,
                power_plant_qualification,
                newUser.plan,
                seller,
                newUser.utility_company,
                this.agent_email,
              )
                .then((ret) => {
                  if (ret.status === 200) {
                    if (ret?.data?.results?.some((item) => item.error)) {
                      this.qualificationMessage =
                        " Ainda é necessário qualificar a(s) Unidade(s) Consumidora(s).";
                    }
                    // Se o cliente colocou um Cupom de desconto valido, cria evento no Google Tag Manager
                    if (this.cupom && this.coupon) {
                      //Marca como venda no RDStation
                      setWinOpportunity({
                        event: "SALE",
                        email: newUser.email,
                        sales_value: newUser.average_consumption,
                      })
                        .then(() => {
                          console.log(
                            "Marcado como venda realizada no RDStation",
                          );
                        })
                        .catch((err) => {
                          console.log("Erro ao marcar venda no RDStation");
                          console.error(err);
                        });

                      // Atualiza a quantidade de uso do Cupon
                      if (newUser.cupom && newUser.coupon)
                        updateUsedCoupon(newUser.coupon.id || newUser.cupom.id);
                    }
                  } else {
                    this.qualificationMessage =
                      " Ainda é necessário qualificar a(s) Unidade(s) Consumidora(s).";
                  }
                })
                .catch((err) => {
                  console.error(err);
                  this.qualificationMessage =
                    " Ainda é necessário qualificar a(s) Unidade(s) Consumidora(s).";
                });

              // Cadastra evento Offline no facebook
              const valor = newUser.name.split(" ");
              let nome = valor.shift();
              let sobrenome = valor.join(" ");
              let fb_data = {
                email: newUser.email,
                fn: nome || newUser.name,
                ln: sobrenome || newUser.name,
                phone: newUser.phone,
                gen: newUser.gender,
                extern_id: user.data.id,
                lead_id: newUser.email,
                value: newUser.average_consumption || 250,
                currency: "BRL",
                customer_id: user.data.id,
              };
              if (newUser.address?.city) fb_data.ct = newUser.address.city;
              if (newUser.address?.postal_code)
                fb_data.zip = newUser.address.postal_code;

              setFbEvent(fb_data, "inside_sale", "Purchase");
              this.snack(
                `Venda realizada com sucesso! + ${this.qualificationMessage}`,
                "green",
                "top",
              );
              this.$emit(
                "showStatusSaleSnack",
                true,
                this.qualificationMessage,
              );
              this.$emit("closeDialog");
            })
            .catch((error) => {
              console.error("Erro ao realizar venda!", error.message);
              let err_msg = "Erro ao gravar membro! Contate nosso suporte.";
              if (error.code === "auth/email-already-in-use") {
                err_msg = "Este email está sendo utilizado por outra conta.";
              }
              this.snack(err_msg + " - " + error, "red", "top");
            });
        }
        this.$store.commit("sales/setLoading", false);
      } else {
        this.snack("Preencha todos os campos obrigatórios.", "red", "top");
      }
      this.$store.commit("sales/setLoading", false);
      this.loading_subscription = false;
    },

    showUcsList(plans) {
      this.selected_plans = plans;
      this.showEditUcs = true;
    },

    clear() {
      this.$refs.form.reset();
      this.$refs.form.resetValidation();
    },

    clearForm() {
      this.setIsCorreios(false);
      this.$emit("clearForm");
    },

    setIdPhoto(idPhoto) {
      this.idPhoto = idPhoto;
    },

    setIdEnergyBill(idEnergyBill) {
      this.idEnergyBill = idEnergyBill;
    },

    snack(message, color, ...args) {
      this.snackBar.top = true;
      this.snackBar.bottom = false;
      this.snackBar.left = false;
      this.snackBar.right = false;

      for (const loc of args) {
        this[loc] = true;
      }

      this.snackBar.color = color;
      this.snackBar.snackMessage = message;
      this.snackBar.snackbar = true;
    },

    handleDisableSell(value) {
      this.disabledSell = value;
    },
  },
};
</script>

<style lang="scss" scoped>
.layoutBorder {
  border: 1px solid #efefef !important;
}
</style>
